import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/website/posts";

export const Route = createFileRoute("/admin/_website/posts")({
  component: Page,
});
